import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  const hadController = Boolean(navigator.serviceWorker?.controller)
  let isRefreshing = false
  let registration = null

  // После активации новой версии один раз перезапускаем уже открытое приложение.
  navigator.serviceWorker?.addEventListener('controllerchange', () => {
    if (!hadController || isRefreshing) return
    isRefreshing = true
    window.location.reload()
  })

  // Telegram WebView может долго оставаться открытым, поэтому проверяем обновление
  // не только при запуске, но и при каждом возвращении пользователя в приложение.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      registration?.update().catch(() => {})
    }
  })

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('Service worker active.')
    },
    registered(serviceWorkerRegistration) {
      registration = serviceWorkerRegistration
      console.log('Service worker registered.')
      registration.update().catch(() => {})
    },
    cached() {
      console.log('Content cached for offline use.')
    },
    updatefound() {
      console.log('Downloading new content.')
    },
    updated(serviceWorkerRegistration) {
      console.log('New content available; activating it now.')
      serviceWorkerRegistration.waiting?.postMessage({ type: 'SKIP_WAITING' })
    },
    offline() {
      console.log('No internet connection, running from cache.')
    },
    error(error) {
      console.error('Service worker registration error:', error)
    }
  })
}
